import { TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowRight } from '../ArrowRight.tsx'
import SearchFormAutocomplete from './SearchFormAutocomplete.tsx'
const DISABLE_AUTOCOMPLETE = true

const SearchTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#A0AAB4',
  },
  '& .MuiInput-underline:after': {
    border: 0,
  },
  '& input:focus': {
    border: 0,
  },

  '& .MuiOutlinedInput-root': {
    padding: '0',
    fontSize: 'clamp(16px, 1vw, 20px)',
    fontFamily: 'inherit',
    letterSpacing: 'inherit',
    '& input::placeholder': {
      opacity: 0.6,
    },
    '& .MuiAutocomplete-input': {
      padding: '.7em 1em',
      border: '1px solid var(--color-gray-0)',
      borderBottom: 0,
      color: 'var(--color-gray-900)',
    },
    '& fieldset': {
      border: 0,
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#6F7E8C',
    },
  },
})
// Custom Paper component to conditionally render the dropdown

export const SearchForm = (props: {
  setInputValue: Dispatch<SetStateAction<string>>
  inputValue: string
  sendSubmit: (value: string) => void
  submitDisabled: boolean
  isLoading: boolean
}) => {
  const { t } = useTranslation()
  const [valueChanged, setValueChanged] = useState(false)

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (props.submitDisabled) {
      return
    }

    setValueChanged(false)
    props.sendSubmit(props.inputValue)
  }

  const setInputValue = (value: string) => {
    setValueChanged(true)
    props.setInputValue(value)
  }

  return (
    <form onSubmit={handleSubmit} className="question">
      <label htmlFor="question" className="sr-only">
        {t('question.label')}
      </label>
      <SearchFormAutocomplete
        isLoading={DISABLE_AUTOCOMPLETE || !valueChanged || props.isLoading || props.inputValue.length < 3}
        value={props.inputValue}
        setInputValue={setInputValue}
        renderInput={params => (
          <SearchTextField
            {...params}
            autoFocus={true}
            sx={{ border: 0 }}
            fullWidth
            placeholder={t('question.placeholder')}
            multiline={true}
            onKeyDown={event => {
              // this is needed for multiline support
              if (event.key === 'Enter') {
                if (!document.activeElement?.getAttribute('aria-activedescendant')) {
                  handleSubmit(event)
                }
              }
            }}
          />
        )}
      />

      <button
        type="submit"
        tabIndex={-1}
        className="question__button button button--no-wrap"
        disabled={props.inputValue.length === 0}
      >
        <span>{t('question.buttonText')}</span>
        <ArrowRight />
      </button>
    </form>
  )
}
